import React, { useState, useContext } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AppContext from "../../store/app-context";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SnackBar = ({ type, message }) => {
  const [open, setOpen] = useState(true);
  const appCtx = useContext(AppContext);

  const anchor = {
    vertical: "top",
    horizontal: "left",
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    appCtx.handleErrorState(false);
  };

  return (
    <Snackbar
      anchorOrigin={anchor}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      key={anchor.vertical + anchor.horizontal}
    >
      <Alert onClose={handleClose} severity={type} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
